import React from 'react';
import { Badge, Stack } from '../ui-kit';
import colors from '../../utils/colors';
import SkillIcon from './SkillIcon';

const SkillWarnings = props => {
  const warningStatusOperand = {
    below_required: '<',
    on_required: '=',
    on_buffer: '>',
    below_buffer: '<',
    above_buffer: '>'
  };

  return (
    <Stack direction="horizontal" gap={2} style={{ overflowX: 'auto' }}>
      {(props.arState?.skillStatuses || []).map((status, index) => (
        <Badge key={index} color={colors[status.level]}>
          {status.level === 'on_required'
            ? `${status.assigned_count}`
            : `${status.assigned_count} ${warningStatusOperand[status.level]} ${status.minimum}`}{' '}
          <SkillIcon skill={props.skills.byId[status.skill_id]} />
        </Badge>
      ))}
    </Stack>
  );
};

export default SkillWarnings;
